import React, { Component, PropTypes } from 'react';
import ConfirmButton from '../../../components/buttons/ConfirmButton';
import { SimpleButton, InverseButton, Modal } from 'react-fast-ui';
import EnterForm from '../forms/EnterForm';
import TourneyForm from '../forms/TourneyForm';

const isValid = tourney => {
  const { color, end, location, name, start, acronym } = tourney || {};
  const { address } = (location || {});
  const { city, province } = address || {};

  return (color && end && name && name.length && start && city && province && acronym && acronym.length);
};

export default class TourneyModal extends Component {
  static propTypes = {
    tourney: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onDelete: PropTypes.func,
    additionalFields: PropTypes.func
  };

  static defaultProps = {
    additionalFields: null,
    onDelete: null
  };

  render() {
    const { tourney, additionalFields, onChange, onSave, onDelete, onClose, title, ...rest } = this.props;

    return (
      <Modal onClose={onClose} {...rest}>
        <Modal.Title onClose={onClose}>{title}</Modal.Title>
        <Modal.Body>
          {
            tourney &&
            <EnterForm onSubmit={onSave}>
              <TourneyForm additionalFields={additionalFields} value={tourney} onChange={onChange}/>
            </EnterForm>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className="display-flex flex-direction-row justify-content-flex-end align-items-center">
            <InverseButton className="mg-left-md" onClick={onClose}>
              Cancel
            </InverseButton>
            {
              tourney && tourney.id && onDelete &&
              <ConfirmButton
                className="mg-left-md"
                key="delete"
                type="danger"
                text="Delete"
                caption="Delete this tourney?"
                onConfirm={onDelete}
              />
            }
            <SimpleButton className="mg-left-md" disabled={!isValid(tourney)} onClick={onSave}>
              Save
            </SimpleButton>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/common/components/modals/TourneyModal.jsx